import { render, staticRenderFns } from "./FinancePayoutsRecipient.vue?vue&type=template&id=9fbfa5d6&"
import script from "./FinancePayoutsRecipient.vue?vue&type=script&lang=js&"
export * from "./FinancePayoutsRecipient.vue?vue&type=script&lang=js&"
import style0 from "./FinancePayoutsRecipient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports